import React, { useState, useEffect } from 'react'

import { Button, Dialog, Grid, Icon, Typography, Select, FormHelperText } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';
import { DraggableComponent } from '../../../../components/UiElements/UiElements';
import useStyles from "./styles";
import { formateMdnNumber } from '../../../../../src/components/Common/Extensions';
function ActivatedMessage({ dialogOpenClose, handleClose, accountNumber, phoneNumber,icc, ...props }) {
    const classes = useStyles();
    return (
        <>
            <Dialog
                classes={{ paper: classes.dialogPaper }}
                disableEscapeKeyDown
                open={dialogOpenClose}
                maxWidth="lg"
                PaperComponent={!window.isIpadView ? DraggableComponent : undefined}
                {...props} >
                <div className={classes.activeDialogContent}>
                    <div className={classes.box}>
                        <div className={classes.header} id="draggable-dialog-title">
                            <Typography className={classes.title}>Message</Typography>
                            <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                        </div>



                        <Scrollbars autoHeight autoHeightMax={570}>
                            <div className={classes.content}>

                                <Grid container direction="column">
                                    <h3 style={{ margin: '3px 0px 12px 0' }}>{"Line has been activated with following information"} </h3>
                                </Grid>

                                <Grid row container className={classes.accountInfor}>
                                    <Grid item lg={6} md={6}>
                                        <Typography className={classes.labelText}>Figgers SIM Number:</Typography>
                                        <Typography className={classes.valueText}>{icc}</Typography>
                                    </Grid>
                                    <Grid item lg={6} md={6}>
                                        <Typography className={classes.labelText}>Current Phone Number:</Typography>
                                        <Typography className={classes.valueText}>{formateMdnNumber(phoneNumber)}</Typography>
                                    </Grid>
                                </Grid>

                            </div>
                        </Scrollbars>
                        <div className={classes.footer}>
                            <div className={classes.footerRight}>
                                <Button className={classes.backBtn} onClick={handleClose}>Close</Button>

                            </div>
                        </div>
                    </div>
                </div>
            </Dialog >
        </>
    )
}

export default ActivatedMessage;